import { identity as d, fn as s } from "../common.js";
import { EMPTY_ARRAY as o } from "../value/constants.js";
import { isUndefined as f, isFunction as l, isNullish as c } from "../value/is.js";
const p = (e, t, n) => {
  let r = t.get(e);
  return f(r) && l(n) && (f(r = n(e, t)) || t.set(e, r)), r;
}, A = (e, t = o) => {
  const n = `${e || ""}`.trim(), r = n ? n.split(/(?:\s*,\s*)+/).filter(d) : o;
  return r.length ? r : t;
}, F = (e, t, n) => e.includes(t) ? t : c(t) ? e[0] : e.includes(n) ? n : e[0], _ = s(Array.prototype.some), u = function e(t, n, r = /* @__PURE__ */ new Set()) {
  for (const i of n)
    Array.isArray(i) ? e(t, i, r) : (t && r.delete(i), r.add(i));
  return r;
};
s(u, void 0, !1);
s(u, void 0, !0);
export {
  p as getMappedValue,
  A as listFrom,
  F as pickFrom,
  _ as some
};
